import React, { useMemo } from "react";
import Table from "../../../../../components/Table";
import { formatDisplayDate, formatMoney } from "../formatters";
import styles from "../styles.module.scss";

const MerchantRefundsTable = ({ line }) => {
  const refunds = line.refunds ?? [];
  const lineId = line.id;

  const columns = useMemo(
    () => [
      {
        field: "mid",
        headerName: "MID",
        width: "150px",
        allowSort: false,
        renderCell: (value) => (
          <div className={styles.normalCell}>{value || "—"}</div>
        ),
      },
      {
        field: "dba",
        headerName: "DBA",
        width: "150px",
        allowSort: false,
        renderCell: (value) => (
          <div className={styles.dbaCell}>{value || "—"}</div>
        ),
      },
      {
        field: "transaction_amount",
        headerName: "TRANSACTION AMOUNT",
        width: "150px",
        allowSort: false,
        renderCell: (value) => (
          <div className={styles.dbaCell}>{formatMoney(value)}</div>
        ),
      },
    ],
    [],
  );

  const tableRows = refunds.map((r, idx) => ({
    id: `${lineId}-${r.integer_key ?? idx}`,
    mid: r.mid,
    dba: r.dba_name ?? "—",
    transaction_amount: r.transaction_amount,
  }));

  return (
    <div className={styles.tableContainer}>
      <Table
        columns={columns}
        data={tableRows}
        loading={false}
        onSort={() => {}}
        sortColumn=""
        sortBy=""
        className={styles.chargebackTable}
        disablePaddingOnExpandedRow
      />
    </div>
  );
};

export default MerchantRefundsTable;
